import React, { useState, useEffect, useRef } from "react";

const Dropdown = ({ text, options, selected, width, onOptionSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selected);
  const ref = useRef(null);

  useEffect(() => {
    setSelectedOption(selected);
  }, [selected]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setIsOpen(false); };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    onOptionSelect && onOptionSelect(option);
  };

  const widthClass = width === "full" ? "w-full" : width === "s200" ? "w-fit min-w-[160px]" : width === "s256" ? "w-fit min-w-[200px]" : width === "s280" ? "w-fit min-w-[220px]" : width === "s340" ? "w-fit min-w-[240px]" : "w-fit";

  return (
    <div
      ref={ref}
      className={`relative ${isOpen ? "z-[999]" : "z-0"} ${width === "full" ? "block w-full" : "inline-block"}`}
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-between gap-2 px-3 h-10 bg-gray-50 rounded-xl text-sm text-gray-700 cursor-pointer transition-colors border ${isOpen ? "border-[#147F26]" : "border-gray-200 hover:border-gray-300"} ${widthClass}`}
      >
        <span className="flex-1 truncate text-left text-sm">{selectedOption || text}</span>
        <svg
          className={`w-4 h-4 flex-shrink-0 text-gray-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <ul className="absolute top-full mt-1 left-0 right-0 min-w-full w-max bg-white border border-gray-100 rounded-xl shadow-lg z-[1000] overflow-y-auto max-h-52 py-1 list-none m-0 p-0">
          {options.map((option, idx) => (
            <li
              key={idx}
              onClick={() => handleOptionClick(option)}
              className={`flex items-center justify-between px-3 py-2 text-sm cursor-pointer transition-colors hover:bg-gray-50 ${option === selectedOption ? "text-[#147F26] font-medium" : "text-gray-700"}`}
            >
              <span className="truncate">{option}</span>
              {option === selectedOption && (
                <svg className="w-4 h-4 ml-2 flex-shrink-0 text-[#147F26]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
